/**
 * EFSoft website constants used by more than one component.
 *
 * The phone, e-mail and Facebook link are the sales contact details the site
 * already published before the 03/10/2026 data-placement rule; they are kept
 * in this one module (instead of being repeated in the hero, contact section,
 * footer, legal pages and the chat fallback) until the owner decides whether
 * they should come from the control plane's platform legal info
 * (GET api/restaurant/platform-legal-info). EF-Soft's legal identity
 * (controller name, address, registry numbers) is never hard-coded: the legal
 * pages fetch it, see services/platformLegalInfoService.ts.
 */

export const SITE_URL = 'https://efsoft.eu';

export const CONTACT = {
  phoneDisplay: '+44 7935 501 848',
  phoneHref: 'tel:+447935501848',
  email: 'emil.filip@efsoft.co.uk',
  emailHref: 'mailto:emil.filip@efsoft.co.uk',
  projectEmailHref:
    'mailto:emil.filip@efsoft.co.uk?subject=' + encodeURIComponent('New project enquiry'),
  facebookHref: 'https://www.facebook.com/profile.php?id=61572979287197',
} as const;

export const CHATSERVE_URL = 'https://restaurants.chatserve.eu/for-restaurants';

/** The demo chat the widget embeds (served by this app at /chat/:id). */
export const CHAT_URL = '/chat/55956052-c400-46f0-9234-6265b7bfdd6b';

/** Window event that asks the chat widget to open (e.g. from a "Chat with us" button). */
export const OPEN_CHAT_EVENT = 'efsoft:open-chat';

/** postMessage type the embedded chat sends its parent when Escape is pressed inside it. */
export const CHAT_ESCAPE_MESSAGE = 'efsoft-chat:escape';
